import Vue from 'vue';
import Vuex from 'vuex';
import config from './modules/config';
import userInfo from './userInfo';
import dialog from './dialog';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loading: false,
    isPageIndex: true,
    isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
  },
  mutations: {
    loading(state, data) {
      state.loading = data;
    },
    isPageIndex(state, data) {
      state.isPageIndex = data;
    },
  },
  actions: {
    loading(context, payload) {
      context.commit('loading', payload);
    },
    isPageIndex(context, payload) {
      context.commit('isPageIndex', payload);
    },
  },
  modules: {
    config,
    userInfo,
    dialog,
  },
  strict: true,
});
